import React, {useRef, useState} from "react";
import {Text, View, StyleSheet, Image, TextInput, TouchableOpacity, ActivityIndicator, Platform} from 'react-native';
import { RFPercentage, RFValue } from "react-native-responsive-fontsize";
import Config from '../../Config';
import axios from "axios";
import Toast from "../Components/Toast";
import AsyncStorage from '@react-native-async-storage/async-storage';


const Code = ({route,navigation})=>{

    const inputRefs1 = useRef(null);
    const inputRefs2 = useRef(null);
    const inputRefs3 = useRef(null);
    const inputRefs4 = useRef(null);
    const inputRefs5 = useRef(null);


    let [disable,setDisable] = React.useState(false);

    React.useEffect(()=>{
        setCode('');
        SetCounter(60);
    },[])


    let [counter,SetCounter] = useState(60);
    let [code,setCode] = useState('');
    let [phone,setPhone] = useState(route.params.phone);
    // let [phone,setPhone] = useState('09358645549');

    const convertNumbersToEnglish = (str) => {
        return str.replace(/[۰-۹٠-٩]/g, (char) =>
            ("۰۱۲۳۴۵۶۷۸۹٠١٢٣٤٥٦٧٨٩".indexOf(char) % 10).toString()
        );
    };





    const insertcode = (text) => {

        text = convertNumbersToEnglish(text);
        if (text.length === 1 ){
            setCode(prevState => prevState + text.toString())
        }else{
            if (code.toString().length > 1) { // بررسی وجود ارقام
                let updatedCode = Math.floor(code / 10); // حذف آخرین رقم
                setCode(updatedCode);
            }else{
                setCode('');
            }
        }
    };


    const tryLogin = async ()=>{

        let formData = new FormData();
        formData.append('phone', route.params.phone);
        formData.append('code', code);
        setDisable(true);
        let res = await axios.post(
            `${Config.api}/auth/code`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            }
        );
        setDisable(false);



        if(res.data.code == 1){
            await AsyncStorage.setItem('token', String(res.data.token));
            navigation.reset({
                index: 0,
                routes: [{ name: "Home" }],
            });
        }else{
           Toast(res.data.error);
            setCode('');
        }
    }





    const resend = async ()=>{



        setDisable(true);

        let formData = new FormData();
        formData.append('phone', phone);




        // Toast.showLoading('ارسال دیتا ...');
        let res = await axios.post(
            `${Config.api}/auth/phone`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            }
        );
        setDisable(false);


        if(res.data.code == 1){
            SetCounter(60);
            setCode('');

        }else{
            Toast(res.data.error);

        }
    }


    React.useEffect(() => {
        // setTimeout(()=>{
        //     inputRefs1.current.focus();
        // },200)

        let fn = setInterval(() => {
            SetCounter(prevState => {
                if(prevState === 0){
                    clearInterval(fn);
                }else{
                    return (prevState - 1);
                }
            });
        },1000);
        return () => {
            clearInterval(fn);
        };
    })


    return (
        <View style={styles.container}>
            <View style={styles.header}>
                <Image
                    resizeMode={'stretch'}
                    fadeDuration={999}
                    style={{
                        width : RFValue(210),
                        height :RFValue(190),
                        marginTop: RFValue(13),

                    }}
                    source={require('../../assets/images/code.png')}
                />
            </View>
            <View style={styles.body}>


                <Text style={styles.title}>
                    اعتبار سنجی
                    {/*{code}*/}
                </Text>

                <View style={styles.row}>
                   <View style={styles.col}>

                       <Text style={styles.subtitle}>
                           لطفا کد 5 رقمی ارسال شده به
                       </Text>
                       <Text style={styles.number}>
                           {` `}
                           {phone}
                           {` `}
                       </Text>
                       <Text style={styles.subtitle}>
                           را وارد کنید
                       </Text>
                   </View>

                    <TouchableOpacity onPress={()=>navigation.goBack()}>

                        <Image
                            resizeMode={'stretch'}
                            fadeDuration={999}
                            style={{
                                width : RFValue(15),
                                height :RFValue(15),

                            }}
                            source={require('../../assets/images/pencil.png')}
                        />
                    </TouchableOpacity>
                </View>

                <View style={styles.rowinput}>

                    <View style={styles.input}>
                        <TextInput
                            placeholderTextColor={'#B1B1B1'}
                            value={code[0]}
                            key={1}
                            ref={inputRefs1}
                            placeholder={'x'}

                            onChangeText={(text)=>{
                                if (text.length === 1 ){
                                    inputRefs2.current.focus();
                                    insertcode(text);
                                }else{
                                    setCode('');
                                    inputRefs1.current.focus();
                                }

                            }}
                           style={styles.txtinput}
                            keyboardType={'numeric'}
                            maxLength={1}
                        />
                    </View>

                    <View style={styles.input}>
                        <TextInput
                            placeholderTextColor={'#B1B1B1'}
                            key={2}
                            ref={inputRefs2}
                            value={code[1]}
                            style={styles.txtinput}
                            keyboardType={'numeric'}
                            maxLength={1}
                            placeholder={'x'}

                            onChangeText={(text)=>{
                                if (text.length === 1 ){
                                    inputRefs3.current.focus();
                                    insertcode(text);
                                }else {
                                    setCode('');
                                    inputRefs1.current.focus();
                                }

                            }}

                        />
                    </View>

                    <View style={styles.input}>
                        <TextInput

                            key={3}
                            ref={inputRefs3}

                            placeholderTextColor={'#B1B1B1'}
                            value={code[2]}

                            onChangeText={(text)=>{}}
                           style={styles.txtinput}
                            keyboardType={'numeric'}
                            maxLength={1}
                            placeholder={'x'}


                            onChangeText={(text)=>{
                                if (text.length === 1 ){
                                    inputRefs4.current.focus();
                                    insertcode(text);
                                }else {
                                    setCode('');
                                    inputRefs1.current.focus();
                                }

                            }}
                        />
                    </View>

                    <View style={styles.input}>
                        <TextInput
                            value={code[3]}
                            key={4}
                            ref={inputRefs4}
                            placeholderTextColor={'#B1B1B1'}

                            onChangeText={(text)=>{}}
                           style={styles.txtinput}
                            keyboardType={'numeric'}
                            maxLength={1}
                            placeholder={'x'}

                            onChangeText={(text)=>{
                                if (text.length === 1 ){
                                    inputRefs5.current.focus();
                                    insertcode(text);
                                }else {
                                    setCode('');
                                    inputRefs1.current.focus();
                                }

                            }}
                        />
                    </View>

                    <View style={styles.input}>
                        <TextInput
                            value={code[4]}
                            key={5}
                            ref={inputRefs5}

                            placeholderTextColor={'#B1B1B1'}

                            onChangeText={(text)=>{}}
                           style={styles.txtinput}
                            keyboardType={'numeric'}
                            maxLength={1}
                            placeholder={'x'}

                            onChangeText={(text)=>{
                                if (text.length === 1 ){
                                    inputRefs5.current.blur();
                                    insertcode(text);
                                }else {
                                    setCode('');
                                    inputRefs1.current.focus();
                                }

                            }}
                        />
                    </View>

                </View>



                <View style={styles.rowresend}>

                    {counter ?
                        <>
                            <ActivityIndicator  color="#1F5CB4" />
                            <Text style={styles.resend} >
                                {counter} ثانیه تا ارسال مجدد  کد
                            </Text>
                        </>
                    :
                     <TouchableOpacity disabled={disable} onPress={resend}>
                         <Text style={styles.resend2} >
                             ارسال مجدد کد
                         </Text>
                     </TouchableOpacity>
                    }


                </View>


                {disable ?
                    <View style={{flex: 1, justifyContent: 'center'}}>
                        <TouchableOpacity disabled={disable} onPress={tryLogin} style={styles.button}>
                            <Text style={styles.buttonText}>بررسی کد ... </Text>
                        </TouchableOpacity>
                    </View>

                    :
                    <View style={{flex: 1, justifyContent: 'center'}}>
                        <TouchableOpacity disabled={disable} onPress={tryLogin} style={styles.button}>
                            <Text style={styles.buttonText}>تائید و ادامه </Text>
                        </TouchableOpacity>
                    </View>

                }









            </View>
        </View>
    );
}

export default Code;
const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor : '#FAFAFA',
    },
    header: {
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: RFValue(15),
        zIndex : 10
    },
    body : {
        flex: 1,

        paddingHorizontal: RFValue(30),

        justifyContent: 'flex-start',
    },
    title: {
        fontSize: RFValue(20),
        fontFamily: 'yk',
        fontWeight :'800',
        color: Config.maincolor,
        textAlign: 'center',
        marginTop: RFValue(28),
    },
    subtitle : {
        fontSize: RFValue(9),
        color: Config.maincolor,
        marginTop: RFValue(12),
        fontFamily: 'yk',
    },
    resend : {
        fontSize: RFValue(12),
        color: '#B1B1B1',
        marginTop: RFValue(12),
        fontFamily: 'yk',
        paddingRight : RFValue(5),
        paddingBottom : RFValue(10),
    },
    resend2 : {
        fontSize: RFValue(12),
        color: Config.maincolor,
        marginTop: RFValue(12),
        fontFamily: 'ykb',
        paddingRight : RFValue(5),
        paddingBottom : RFValue(10),
    },
    number : {
        fontSize: RFValue(14),
        color: '#1F5CB4',
        marginTop: RFValue(9),
        // paddingHorizontal: RFValue(30),
        // marginHorizontal: RFValue(30),

        fontFamily: 'yk',
    },
    number2 : {
        fontSize: RFValue(14),
        color: '#1F5CB4',


        fontFamily: 'yk',
    },
    row : {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },

    rowinput : {
        flexDirection: 'row-reverse',
        justifyContent: 'space-around',
        alignItems: 'center',
    },
    input :{
        borderStyle:'solid',
        borderColor:'#E7E9F2',
        borderWidth:1,
        borderRadius : RFValue(10),
        padding : RFValue(1),
        marginTop : RFValue(20),
        width : RFValue(50),
        height:RFValue(50),
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor:'#FFF',
    },
    txtinput : {
        fontSize: RFValue(14),
        textAlign: 'center',
        justifyContent: 'center',
        alignItems : 'center',
        // backgroundColor: 'red',
        width: '100%',
    },


    rowresend : {
      flexDirection: 'row',
      marginTop : RFValue(20),
        justifyContent: 'center',
        alignItems: 'center',
        textAlign : 'center',
        width : '100%',

        // backgroundColor:'#E7E9F2',
    },

    buttonText : {
        fontFamily : 'yk',
        fontSize : RFValue(16),
        color : Config.maincolor,
    },
    button : {
        backgroundColor: Config.secondcolor,
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop : -RFValue(40),
        borderRadius : RFValue(10),
        height : RFValue(40),

    },
    col :{
        flexDirection: 'row',
    }
})